module.exports = __webpack_public_path__ + "static/media/hamburger-menu.cb887fac.svg";